import { Image, Stack } from "@chakra-ui/react";

import type { PropsWithChildren } from "react";

interface ExtraProps extends PropsWithChildren {
	alt: string;
	image: string;
}

export const Extra = ({ alt, image, children }: ExtraProps) => {
	return (
		<Stack
			gap="0"
			rounded="6"
			border={{ md: "solid 3px" }}
			borderColor={{ md: "brand.mid" }}
		>
			<Image
				alt={alt}
				src={image}
				objectFit="cover"
				rounded={{ base: "0", md: "3" }}
				h={{ base: "300px", md: "260px" }}
				onContextMenu={(e) => e.preventDefault()}
			/>
			<Stack p="4" h={{ md: "100%" }} gap="3.5" justify="space-between">
				{children}
			</Stack>
		</Stack>
	);
};
